import glossary from './glossary';
import sentences from './sentences';
import validation from './validation';

export default {
  glossary,
  sentences,
  validation,
};
